import { atom } from 'jotai';

// Short message at the top right (ex: "Vidéo ajoutée à tes favoris", "Signalement rejeté"). The id
// starts it again when the same text comes twice. Success by default.
type ToastSeverity = 'success' | 'warning' | 'error';

interface Toast {
  id: number;
  text: string;
  severity?: ToastSeverity;
}

const toastAtom = atom<Toast | null>(null);

export type { Toast, ToastSeverity };

export { toastAtom };
